import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc246064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Client manger", -1))
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "label"
}
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  key: 4,
  class: "label"
}
const _hoisted_8 = { key: 5 }
const _hoisted_9 = {
  key: 6,
  class: "label"
}
const _hoisted_10 = { key: 7 }
const _hoisted_11 = {
  key: 8,
  class: "label"
}
const _hoisted_12 = { key: 9 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("cancel")

import "@/assets/css/action-buttons.css";

import {
  ref,
  withDefaults,
  watch,
  computed,
  Ref,
} from "vue";
import BaseCommandModal from "../ActionModals/_BaseCommandModal.vue";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { Loader as KLoader } from "@progress/kendo-vue-indicators";
import { DateRangePicker as KDateRangePicker } from "@progress/kendo-vue-dateinputs";

import ActionResultMessage from "./Components/ActionResultMessage.vue";

import {
  ClientManager,
  ClientManagerItem,
  CommissionUserRole,
} from "../typesAndConstants";

import * as api from "../api";
import {  makeAuditedCommandParams, strIsoOfDate } from "../helpers";
//#endregion

type UserKind = "client" | "manager";

type ModalProps = {
  show?: boolean;
  clientManager: ClientManager;
  model?: ClientManagerItem | null;
  userKind: UserKind;
};

//#region PROPS

const __default__ = {
  name: "RecalculateCommissionsModal",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    clientManager: null,
    model: { default: null },
    userKind: null
  },
  emits: ["command-executed", "close-modal"],
  setup(__props: any, { emit }) {

const props = __props as { show: boolean, clientManager: ClientManager, model: ClientManagerItem | null, userKind: UserKind }

//#region IMPORTS

// Global CSS

//#endregion

//#region EMITS

//#endregion

const makeAuditValue = () => ({
  StartDate: strIsoOfDate(dataRange.value.start),
  EndDate: strIsoOfDate(dataRange.value.end),
});

const makeCommandParams = () => {
  const oldValue = null;
  const newValue = makeAuditValue();
  const [userRole, userId] =
    props.userKind == "manager"
      ? [CommissionUserRole.ClientManager, clientManagerId.value]
      : [CommissionUserRole.Client, clientId.value];

  return makeAuditedCommandParams(
    userRole,
    userId,
    oldValue,
    newValue,
    note.value,
  );
};

const today = new Date();

const dataRange = ref({
  start: new Date(today.getFullYear(), today.getMonth(), 1),
  end: today,
});
const calculating = ref(false);
const showActionResultMessage = ref(false);
const note = ref("");

const errorMessages: Ref<string[]> = ref([]);
const hasError = computed(() => !!errorMessages.value.length);
const clientManagerId = computed(() => props.clientManager.Id ?? 0);
const clientId = computed(() => props.model?.ClientId ?? 0);
watch(
  () => props.model,
  (n, o) => {
    errorMessages.value = [];
    showActionResultMessage.value = false;
  },
);

const transferred = computed(() => (props.model?.Transferred ? "Yes" : "No"));

//#region EVENT HANDLERS
const onCloseModal = (): void => emit("close-modal");

const onCancel = () => emit("close-modal");
const onDateChange = (event: any) => {
  dataRange.value = event.value;
};
const onCalculate = async () => {
  try {
    errorMessages.value = [];
    showActionResultMessage.value = false;
    calculating.value = true;
    await api.recalculateCommissions(makeCommandParams());
    emit("command-executed");
  } catch (error: any) {
    errorMessages.value.push(error?.message ? error?.message : error);
  } finally {
    calculating.value = false;
    showActionResultMessage.value = true;
  }
};

const onNoteChange = (event: any): void => {
  note.value = event.value;
};

//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCommandModal, {
    show: props.show,
    title: 'Recalculate Commissions',
    onCloseModal: onCloseModal,
    onNoteChanged: onNoteChange
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, _toDisplayString(props.clientManager.FullName.slice(4)), 1),
        (props.model?.Client)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Client"))
          : _createCommentVNode("", true),
        (props.model?.Client)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.model?.Client), 1))
          : _createCommentVNode("", true),
        (props.model?.ClientEmail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Client email"))
          : _createCommentVNode("", true),
        (props.model?.ClientEmail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(props.model?.ClientEmail), 1))
          : _createCommentVNode("", true),
        (props.model?.ClientType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Client type"))
          : _createCommentVNode("", true),
        (props.model?.ClientType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(props.model?.ClientType), 1))
          : _createCommentVNode("", true),
        (props.model?.AssignedOn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Assigned on"))
          : _createCommentVNode("", true),
        (props.model?.AssignedOn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(props.model?.AssignedOn), 1))
          : _createCommentVNode("", true),
        (props.model?.Transferred)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Transferred"))
          : _createCommentVNode("", true),
        (props.model?.Transferred)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(transferred)), 1))
          : _createCommentVNode("", true),
        _hoisted_13,
        _createElementVNode("div", null, [
          _createVNode(_unref(KDateRangePicker), {
            "default-show": false,
            value: dataRange.value,
            onChange: onDateChange
          }, null, 8, ["value"])
        ])
      ]),
      (showActionResultMessage.value)
        ? (_openBlock(), _createBlock(ActionResultMessage, {
            key: 0,
            "has-error": _unref(hasError),
            "error-messages": errorMessages.value
          }, null, 8, ["has-error", "error-messages"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(KButton), {
        class: "action danger",
        onClick: onCalculate
      }, {
        default: _withCtx(() => [
          (calculating.value)
            ? (_openBlock(), _createBlock(_unref(KLoader), {
                key: 0,
                "theme-color": 'light',
                type: 'pulsing'
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, "Calculate"))
        ]),
        _: 1
      }),
      _createVNode(_unref(KButton), {
        class: "action no-action",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})